import { Registration } from "@p0security/shared/integrations/types";

import { AwsS3AuditComponents } from "./components.ts";

export const AwsS3AuditIconUrl =
  "https://upload.wikimedia.org/wikipedia/commons/b/bc/Amazon-S3-Logo.svg";

export const AwsS3AuditRegistration = Registration({
  category: "other",
  components: AwsS3AuditComponents,
  docs: {},
  itemKind: "bucket",
  label: "Amazon S3 (audit logs)",
  logoUrl: AwsS3AuditIconUrl,
  maturity: "beta",
});
